import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Stack, Typography } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';

import Countries from 'enum/Countries';
import ThreatGeoChip from 'components/ThreatGeoChip';

const ThreatRegionCard = ({ region, index }) => {
  const { country } = region;
  const countryCode = Countries.find((c) => c.name === country)?.countryCode;

  return (
    <Grid item xs={60} sm={30} md={20} xl={12}>
      <Stack
        sx={{
          position: 'relative',
          p: '20px 16px 16px 24px',
          borderRadius: '6px',
          bgcolor: '#072645',
        }}
        rowGap={3}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 8,
            height: '100%',
            bgcolor: '#485868',
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
          }}
        />
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing="10px">
            <ReactCountryFlag countryCode={countryCode.toUpperCase()} style={{ width: '36px', height: '24px' }} svg />
            <Typography color="#FFF" sx={{ fontSize: 14, fontWeight: 500 }} data-testid="threat_geo-country">
              {country}
            </Typography>
          </Stack>
          <Typography
            sx={{
              width: 32,
              height: 32,
              borderRadius: 16,
              bgcolor: '#153B60',
              color: '#11AEFB',
              fontSize: 20,
              lineHeight: '32px',
              textAlign: 'center',
            }}
            data-testid="threat_geo-country_index"
          >
            {index}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={4}>
          {Object.keys(region.severity).map((severity) => (
            <ThreatGeoChip
              key={severity}
              countryCode={countryCode}
              severity={severity}
              text={region.severity[severity]}
            />
          ))}
        </Stack>
      </Stack>
    </Grid>
  );
};

ThreatRegionCard.propTypes = {
  region: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default ThreatRegionCard;
